import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, of, tap } from 'rxjs';
import { AuthService } from '../../../auth/core/services/AuthService';
import { IdentityStore } from '../../../auth/core/stores/IdentityStore';
import { TerminalSessionStatuses } from '../enums/TerminalSessionStatuses';
import { ITerminal } from '../interfaces/ITerminal';
import { TerminalsService } from '../services/TerminalsService';
import { TerminalsStore } from '../stores/TerminalsStore';

export const terminalResolver: ResolveFn<ITerminal | true> = () => {
  const selectedTerminal = inject(TerminalsStore).selectedTerminal();
  const authService = inject(AuthService);

  if (inject(IdentityStore).identity() && selectedTerminal) {
    return inject(TerminalsService).getTerminalById(selectedTerminal.id).pipe(
      map(res => res.data),
      tap((res) => {
        if (res.currentSession?.sessionStatus !== TerminalSessionStatuses.Opened) {
          authService.logout();
        }
      })
    );
  } else {
    return of(true);
  }
};
